export default __webpack_public_path__ + "static/13-294c6df2617dbb5005a137993fae4764.gif";